import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionJobsForEventsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
}>;


export type GetProductionJobsForEventsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, productionJobId: string, jobNumber: number, categoryName: string, color: string, genus: string, series: string, quantity: number, eaches: number, unitLabel: string, yield: number, jobExecutionStatus: Types.JobExecutionStatus, parentProductionJobId?: string | null, postingStatus: Types.JobPostingStatus, locationId?: string | null, locationName?: string | null, lotStatus: Types.ProductionLotStatus, productionLotId: string, productionRecipeId: string, productionPlanName: string, customerId?: string | null, customerName?: string | null, notes?: string | null, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartIsoWeek: number, weekStartIsoYear: number, totalTaskCount: number, completedTaskCount: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, taskEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, defaultAssignedTo?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionJobIdsForEventsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
}>;


export type GetProductionJobIdsForEventsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type EventsProductionJobSummaryFragment = { __typename?: 'ProductionJobDocument', id: string, productionJobId: string, jobNumber: number, categoryName: string, color: string, genus: string, series: string, quantity: number, eaches: number, unitLabel: string, yield: number, jobExecutionStatus: Types.JobExecutionStatus, parentProductionJobId?: string | null, postingStatus: Types.JobPostingStatus, locationId?: string | null, locationName?: string | null, lotStatus: Types.ProductionLotStatus, productionLotId: string, productionRecipeId: string, productionPlanName: string, customerId?: string | null, customerName?: string | null, notes?: string | null, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number, weekStartIsoWeek: number, weekStartIsoYear: number, totalTaskCount: number, completedTaskCount: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, taskEventAttachments: Array<{ __typename?: 'ProductionJobEventAttachmentDocument', eventId: string, defaultAssignedTo?: string | null }> };

export const EventsProductionJobSummaryFragmentDoc = new TypedDocumentString(`
    fragment EventsProductionJobSummary on ProductionJobDocument {
  id
  productionJobId
  jobNumber
  categoryName
  color
  genus
  series
  quantity
  eaches
  unitLabel
  yield
  jobExecutionStatus
  parentProductionJobId
  postingStatus
  locationId
  locationName
  lotStatus
  productionLotId
  productionRecipeId
  productionPlanName
  customerId
  customerName
  notes
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartIsoWeek
  weekStartIsoYear
  totalTaskCount
  completedTaskCount
  taskEventAttachments {
    eventId
    defaultAssignedTo
  }
  createdAt
  updatedAt
}
    `, {"fragmentName":"EventsProductionJobSummary"});
export const GetProductionJobsForEventsDocument = new TypedDocumentString(`
    query GetProductionJobsForEvents($first: Int, $after: String, $last: Int, $before: String, $where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!]) {
  productionJobs(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      ...EventsProductionJobSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment EventsProductionJobSummary on ProductionJobDocument {
  id
  productionJobId
  jobNumber
  categoryName
  color
  genus
  series
  quantity
  eaches
  unitLabel
  yield
  jobExecutionStatus
  parentProductionJobId
  postingStatus
  locationId
  locationName
  lotStatus
  productionLotId
  productionRecipeId
  productionPlanName
  customerId
  customerName
  notes
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
  weekStartIsoWeek
  weekStartIsoYear
  totalTaskCount
  completedTaskCount
  taskEventAttachments {
    eventId
    defaultAssignedTo
  }
  createdAt
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionJobIdsForEventsDocument = new TypedDocumentString(`
    query GetProductionJobIdsForEvents($first: Int, $after: String, $where: ProductionJobDocumentFilterInput) {
  productionJobs(first: $first, after: $after, where: $where) {
    nodes {
      productionJobId
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionJobsForEvents: build.query<GetProductionJobsForEventsQuery, GetProductionJobsForEventsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionJobsForEventsDocument, variables })
    }),
    GetProductionJobIdsForEvents: build.query<GetProductionJobIdsForEventsQuery, GetProductionJobIdsForEventsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionJobIdsForEventsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionJobsForEventsQuery, useLazyGetProductionJobsForEventsQuery, useGetProductionJobIdsForEventsQuery, useLazyGetProductionJobIdsForEventsQuery } = injectedRtkApi;
